import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const EarthHomeWorld = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M3 12H7.172C8.734 12 10 10.734 10 9.172V9.172C10 8.422 9.702 7.702 9.172 7.172L6.717 4.717" />
      <path d="M18.292 18.438L16.515 15.773C16.193 15.29 15.652 15 15.072 15V15C14.415 15 13.815 14.629 13.521 14.041L13.388 13.775C13.144 13.287 13.144 12.712 13.388 12.224L14.521 9.958C14.814 9.371 15.415 9 16.072 9H20.48" />
      <path d="M12 3C16.982 3 21 7.018 21 12C21 16.982 16.982 21 12 21" />
      <path d="M12 21C7.018 21 3 16.982 3 12C3 7.018 7.018 3 12 3" />
    </svg>
  );
};
